import script from "./xtx-carousel.vue?vue&type=script&setup=true&lang=js"
export * from "./xtx-carousel.vue?vue&type=script&setup=true&lang=js"

import "./xtx-carousel.vue?vue&type=style&index=0&id=0b994ed2&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b994ed2"]])

export default __exports__